<div class="shimmer" [ngStyle]="{ width: width,  height: shimmerHeight, borderRadius: shimmerBorderRadius }"></div>
